import React from 'react';

import './categorizerStub.scss';

const CategorizerStub: React.FC = () => {
    return <div styleName="container" />;
};

export default CategorizerStub;
